"use strict";
import React, { cloneElement, Children, Component } from "react";
import classNames from "classnames";
import { TabsContext } from "./Tabs";
import { TransitionGroup, Transition } from "react-transition-group";
import { AnimationDuration } from "../../../styles/Animations";
import forceReflow from "../../../utils/forceReflow";
class TabPanels extends Component {
  constructor() {
    super(...arguments);
    this.getDirection = (child) => {
      const { selectedIndex, prevSelectedIndex } = this.context;
      if (selectedIndex > prevSelectedIndex)
        return child.props.in ? 1 : -1;
      return child.props.in ? -1 : 1;
    };
  }
  render() {
    const { children, className, transitionHeight } = this.props;
    const { selectedIndex, panelHeight, animating } = this.context;
    const panelsHeight = transitionHeight && panelHeight !== 0 ? panelHeight : void 0;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("tabs__tab-panels", className, { "tabs__tab-panels--animating": animating }),
        style: { height: panelsHeight }
      },
      /* @__PURE__ */ React.createElement(
        TransitionGroup,
        {
          component: null,
          childFactory: (child) => cloneElement(child, {
            direction: this.getDirection(child)
          })
        },
        Children.toArray(children).filter(Boolean).map(
          (child, index) => index === selectedIndex && /* @__PURE__ */ React.createElement(Transition, { key: `tab-panel-${index}`, timeout: AnimationDuration.Short, onEnter: forceReflow }, (status, { direction }) => cloneElement(child, { index, status, direction }))
        )
      )
    );
  }
}
TabPanels.contextType = TabsContext;
export default TabPanels;
